import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import EventEmitter from "./EventEmitter";
import Experience from "../Experience";

export default class Resources extends EventEmitter {
  constructor() {
    super();

    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.assets = {};

    this.toLoad = 0;
    this.loaded = 0;
    this.failed = 0;

    this.setLoaders();
    // this.loadTextures(sources);
  }

  setLoaders() {
    this.loaders = {};

    this.loaders.textureLoader = new THREE.TextureLoader();
    this.loaders.gltfLoader = new GLTFLoader();
  }

  loadImagesBlobs(assets, onProgress) {
    let loadedCount = 0;

    const promises = assets.map(async (asset) => {
      const response = await fetch(asset);
      const blob = await response.blob();
      loadedCount++;
      if (onProgress)
        onProgress(Math.round((loadedCount / assets.length) * 100));

      return URL.createObjectURL(blob);
    });

    return Promise.all(promises);
  }

  // retry(asset, error, currentAttempt, attempts) {
  //   if (currentAttempt < attempts) {
  //     setTimeout(() => {
  //       this.loadTexture(asset, currentAttempt, attempts);
  //     }, 200);
  //   } else {
  //     console.error(error);
  //     this.failed++;
  //     this.checkIfLoaded();
  //   }
  // }

  // loadTexture(asset, currentAttempt = 1, attempts = 3) {
  //   if (asset.type === "texture") {
  //     this.loaders.textureLoader.load(
  //       asset.path,
  //       (texture) => {
  //         this.sourceLoaded(asset, texture);
  //       },
  //       undefined,
  //       (error) => {
  //         this.retry(asset, error, currentAttempt + 1, attempts);
  //       },
  //     );
  //   } else if (asset.type === "gltfModel") {
  //     this.loaders.gltfLoader.load(
  //       asset.path,
  //       (gltf) => {
  //         this.sourceLoaded(asset, gltf.scene);
  //       },
  //       undefined,
  //       (error) => {
  //         this.retry(asset, error, currentAttempt + 1, attempts);
  //       },
  //     );
  //   }
  // }

  // loadTextures(assets) {
  //   this.toLoad = assets.length;
  //   this.loaded = 0;
  //   this.textures = new Map();

  //   assets.forEach((asset) => {
  //     this.loadTexture(asset);
  //   });
  // }

  // sourceLoaded(source, file) {
  //   this.textures[source.name] = file;
  //   this.loaded++;

  //   this.checkIfLoaded();
  // }

  // checkIfLoaded() {
  //   if (this.loaded + this.failed === this.toLoad) {
  //     this.trigger("loaded");
  //   }
  // }
}
